var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-white text-primary rounded-full w-10 h-10 shadow-lg flex items-center justify-center",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('IconComponent',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }